import { modalHide } from "app/App/actions";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import {
    Button,
    LoadingButton,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    RequestMessage,
} from "ui";
import { IBulkContextModal } from "../interfaces";
import useRequest from "api/useRequest";
import { TextField } from "@mui/material";
import { AxiosResponse } from "axios";
import { translateContextBulk } from "../actions";

const MODAL_NAME = "TranslationsBulkContextModal";

const TranslationsBulkContextModal: FC<IBulkContextModal> = ({
    selected,
    project,
    onSuccess,
}) => {
    const dispatch = useDispatch();
    const [context, setContext] = useState("");
    const { isLoading, message, request, status } = useRequest();

    const handleClose = () => {
        dispatch(modalHide(MODAL_NAME));
    };

    const handleSubmit = () => {
        request(
            translateContextBulk(
                project,
                { ids: selected, context },
                (response: AxiosResponse) => {
                    if (response.status < 300) {
                        handleClose();
                        onSuccess();
                    }
                },
            ),
        );
    };

    return (
        <Modal open maxWidth="sm" fullWidth>
            <ModalTitle onClose={handleClose}>Bulk set context</ModalTitle>
            <ModalContent>
                {status >= 400 && (
                    <RequestMessage
                        status={status}
                        message={message}
                        sx={{ mb: 2 }}
                    />
                )}
                <TextField
                    autoFocus
                    fullWidth
                    multiline
                    minRows={4}
                    maxRows={12}
                    label="Context"
                    value={context}
                    onChange={(e) => setContext(e.target.value)}
                />
            </ModalContent>
            <ModalActions>
                <Button
                    onClick={handleClose}
                    color="inherit"
                    variant="text"
                    sx={{ mr: 1 }}
                >
                    Cancel
                </Button>
                <LoadingButton
                    loading={isLoading}
                    variant="outlined"
                    color="secondary"
                    onClick={handleSubmit}
                >
                    Save
                </LoadingButton>
            </ModalActions>
        </Modal>
    );
};

export default TranslationsBulkContextModal;
